import capitalize from 'lodash.capitalize'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useSelector } from 'react-redux'

import InfluencerIdentityRowLabelTooltip from '@components/InfluencerIdentity/Row/LabelTooltip'
import InfluencerIdentityRowValueAndLabel from '@components/InfluencerIdentity/Row/ValueAndLabel'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import hooks from '@hooks'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectInfluencerIdentityPostCount } from '@store/influencerIdentities'

const InfluencerIdentityRowPerformancePostCount = () => {
  const campaignId = useCampaignIdFromRoute()
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const postCount = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityPostCount(state, campaignId, contextInfluencerIdentityId),
  )
  const { currentFilter } = hooks.useInboxFilter()

  return (
    <InfluencerIdentityRowValueAndLabel
      value={<FormattedNumber value={postCount} />}
      label={
        <InfluencerIdentityRowLabelTooltip
          title={<FormattedMessage id="submission.performance.post" values={{ postCount }} />}
          body={
            <FormattedMessage
              id="submission.performance.post.body"
              values={{ filter: capitalize(currentFilter) }}
            />
          }
        >
          <FormattedMessage id="submission.performance.post" values={{ postCount }} />
        </InfluencerIdentityRowLabelTooltip>
      }
      width={4.375}
      name="influencer-identity-row-post-count"
    />
  )
}

export { InfluencerIdentityRowPerformancePostCount }

export default InfluencerIdentityRowPerformancePostCount
